export { default } from './chainPropTypes';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/chainPropTypes/index.js
// module id = 44
// module chunks = 22